/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRoamingAddClientAppEmailPost } from '../fn/app-id/api-roaming-add-client-app-email-post';
import { ApiRoamingAddClientAppEmailPost$Params } from '../fn/app-id/api-roaming-add-client-app-email-post';
import { apiRoamingAddClientAppPhonePost } from '../fn/app-id/api-roaming-add-client-app-phone-post';
import { ApiRoamingAddClientAppPhonePost$Params } from '../fn/app-id/api-roaming-add-client-app-phone-post';
import { apiRoamingCheckLoginAppEmailPost } from '../fn/app-id/api-roaming-check-login-app-email-post';
import { ApiRoamingCheckLoginAppEmailPost$Params } from '../fn/app-id/api-roaming-check-login-app-email-post';
import { apiRoamingCheckLoginAppPhonePost } from '../fn/app-id/api-roaming-check-login-app-phone-post';
import { ApiRoamingCheckLoginAppPhonePost$Params } from '../fn/app-id/api-roaming-check-login-app-phone-post';
import { apiRoamingCheckloginappPost } from '../fn/app-id/api-roaming-checkloginapp-post';
import { ApiRoamingCheckloginappPost$Params } from '../fn/app-id/api-roaming-checkloginapp-post';
import { apiRoamingFinregClientAppEmailPost } from '../fn/app-id/api-roaming-finreg-client-app-email-post';
import { ApiRoamingFinregClientAppEmailPost$Params } from '../fn/app-id/api-roaming-finreg-client-app-email-post';
import { apiRoamingFinregClientAppPhonePost } from '../fn/app-id/api-roaming-finreg-client-app-phone-post';
import { ApiRoamingFinregClientAppPhonePost$Params } from '../fn/app-id/api-roaming-finreg-client-app-phone-post';
import { RoamingDataApiRoaming } from '../models/roaming-data-api-roaming';

@Injectable({ providedIn: 'root' })
export class ApiRoamingAppIdService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRoamingCheckloginappPost()` */
  static readonly ApiRoamingCheckloginappPostPath = '/api/Roaming/checkloginapp';

  /**
   * Client Authentication by Application ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingCheckloginappPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingCheckloginappPost$Response(params?: ApiRoamingCheckloginappPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiRoamingCheckloginappPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Client Authentication by Application ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingCheckloginappPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingCheckloginappPost(params?: ApiRoamingCheckloginappPost$Params, context?: HttpContext): Observable<void> {
    return this.apiRoamingCheckloginappPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiRoamingAddClientAppPhonePost()` */
  static readonly ApiRoamingAddClientAppPhonePostPath = '/api/Roaming/addClientAppPhone';

  /**
   * Registration of a customer account by phone and application ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingAddClientAppPhonePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingAddClientAppPhonePost$Response(params?: ApiRoamingAddClientAppPhonePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiRoamingAddClientAppPhonePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Registration of a customer account by phone and application ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingAddClientAppPhonePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingAddClientAppPhonePost(params?: ApiRoamingAddClientAppPhonePost$Params, context?: HttpContext): Observable<void> {
    return this.apiRoamingAddClientAppPhonePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiRoamingAddClientAppEmailPost()` */
  static readonly ApiRoamingAddClientAppEmailPostPath = '/api/Roaming/addClientAppEmail';

  /**
   * Registration of the client's account by email and application ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingAddClientAppEmailPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingAddClientAppEmailPost$Response(params?: ApiRoamingAddClientAppEmailPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiRoamingAddClientAppEmailPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Registration of the client's account by email and application ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingAddClientAppEmailPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingAddClientAppEmailPost(params?: ApiRoamingAddClientAppEmailPost$Params, context?: HttpContext): Observable<void> {
    return this.apiRoamingAddClientAppEmailPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiRoamingCheckLoginAppPhonePost()` */
  static readonly ApiRoamingCheckLoginAppPhonePostPath = '/api/Roaming/CheckLoginAppPhone';

  /**
   * Authenticate customer account by phone and appType ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingCheckLoginAppPhonePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingCheckLoginAppPhonePost$Response(params?: ApiRoamingCheckLoginAppPhonePost$Params, context?: HttpContext): Observable<StrictHttpResponse<RoamingDataApiRoaming>> {
    return apiRoamingCheckLoginAppPhonePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Authenticate customer account by phone and appType ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingCheckLoginAppPhonePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingCheckLoginAppPhonePost(params?: ApiRoamingCheckLoginAppPhonePost$Params, context?: HttpContext): Observable<RoamingDataApiRoaming> {
    return this.apiRoamingCheckLoginAppPhonePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoamingDataApiRoaming>): RoamingDataApiRoaming => r.body)
    );
  }

  /** Path part for operation `apiRoamingCheckLoginAppEmailPost()` */
  static readonly ApiRoamingCheckLoginAppEmailPostPath = '/api/Roaming/CheckLoginAppEmail';

  /**
   * Authentication of the client account by email and application ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingCheckLoginAppEmailPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingCheckLoginAppEmailPost$Response(params?: ApiRoamingCheckLoginAppEmailPost$Params, context?: HttpContext): Observable<StrictHttpResponse<RoamingDataApiRoaming>> {
    return apiRoamingCheckLoginAppEmailPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Authentication of the client account by email and application ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingCheckLoginAppEmailPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingCheckLoginAppEmailPost(params?: ApiRoamingCheckLoginAppEmailPost$Params, context?: HttpContext): Observable<RoamingDataApiRoaming> {
    return this.apiRoamingCheckLoginAppEmailPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoamingDataApiRoaming>): RoamingDataApiRoaming => r.body)
    );
  }

  /** Path part for operation `apiRoamingFinregClientAppPhonePost()` */
  static readonly ApiRoamingFinregClientAppPhonePostPath = '/api/Roaming/finregClientAppPhone';

  /**
   * Confirmation of registration by phone and application ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingFinregClientAppPhonePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingFinregClientAppPhonePost$Response(params?: ApiRoamingFinregClientAppPhonePost$Params, context?: HttpContext): Observable<StrictHttpResponse<RoamingDataApiRoaming>> {
    return apiRoamingFinregClientAppPhonePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Confirmation of registration by phone and application ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingFinregClientAppPhonePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingFinregClientAppPhonePost(params?: ApiRoamingFinregClientAppPhonePost$Params, context?: HttpContext): Observable<RoamingDataApiRoaming> {
    return this.apiRoamingFinregClientAppPhonePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<RoamingDataApiRoaming>): RoamingDataApiRoaming => r.body)
    );
  }

  /** Path part for operation `apiRoamingFinregClientAppEmailPost()` */
  static readonly ApiRoamingFinregClientAppEmailPostPath = '/api/Roaming/finregClientAppEmail';

  /**
   * Confirmation of registration by email and application ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingFinregClientAppEmailPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingFinregClientAppEmailPost$Response(params?: ApiRoamingFinregClientAppEmailPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiRoamingFinregClientAppEmailPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Confirmation of registration by email and application ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingFinregClientAppEmailPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiRoamingFinregClientAppEmailPost(params?: ApiRoamingFinregClientAppEmailPost$Params, context?: HttpContext): Observable<void> {
    return this.apiRoamingFinregClientAppEmailPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
